export default import.meta.ROLLUP_FILE_URL_9kBTUqaINCHDANxrI10WCw;